import React from "react";
import { Link } from "react-router-dom";
import renderSoldLabel from "./SoldText";

const ImageLink3 = ({
  source,
  description,
  label,
  sold,
  cssClass,
  linkTo,
  labelLine2,
  dimensions,
  medium,
  year,
  price,
}) => {
  const isExternalLink = linkTo && linkTo.startsWith('http');
  const hasLink = linkTo; // Links work regardless of sold status

  const renderLabel = (label, sold, labelLine2) => {
    if (label && labelLine2) {
      return (
        <div className='imgLinkLabelBox imageSpace'>
          <div className='imageLabel'>
            {hasLink ? (
              isExternalLink ? (
                <a href={linkTo} target="_blank" rel="noopener noreferrer" className='imageLabel'>
                  {label} {renderSoldLabel(sold)}
                </a>
              ) : (
                <Link to={linkTo} className='imageLabel'>
                  {label} {renderSoldLabel(sold)}
                </Link>
              )
            ) : (
              <>
                {label} {renderSoldLabel(sold)}
              </>
            )}
          </div>
          <div className='imageLabel goGreyNow'>{labelLine2}</div>
        </div>
      );
    } else if (label) {
      return (
        <div className='imageLabel imageSpace'>
          {hasLink ? (
            isExternalLink ? (
              <a href={linkTo} target="_blank" rel="noopener noreferrer" className='imageLabel'>
                {label} {renderSoldLabel(sold)}
              </a>
            ) : (
              <Link to={linkTo} className='imageLabel'>
                {label} {renderSoldLabel(sold)}
              </Link>
            )
          ) : (
            <>
              {label} {renderSoldLabel(sold)}
            </>
          )}
        </div>
      );
    }
  };

  return (
    <div className='normalImageContainer'>
      <div className='normalImageBox'>
        {hasLink ? (
          isExternalLink ? (
            <a href={linkTo} target="_blank" rel="noopener noreferrer">
              <img
                src={source}
                alt={description}
                id='normalImage'
                className={cssClass}
                loading='lazy'
              />
            </a>
          ) : (
            <Link to={linkTo}>
              <img
                src={source}
                alt={description}
                id='normalImage'
                className={cssClass}
                loading='lazy'
              />
            </Link>
          )
        ) : (
          <img
            src={source}
            alt={description}
            id='normalImage'
            className={cssClass}
            loading='lazy'
          />
        )}
      </div>

      {renderLabel(label, sold, labelLine2)}

      <div className='abstractImageDetails'>
        {dimensions && <div>{dimensions}</div>}
        {medium && <div>{medium}</div>}
        {year && <div>{year}</div>}
        {price && <div>{price}</div>}
      </div>
    </div>
  );
};

export default ImageLink3;